import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const sanityClient = createClient({
  projectId: '1ujrjnxn', // Proyecto principal → multimack-panel.sanity.studio
  dataset: 'production',
  useCdn: true,
  apiVersion: '2024-03-24',
});

// Cache simple para acelerar la navegación entre páginas
const queryCache = new Map();

export const cachedFetch = async (query: string, params = {}) => {
  const cacheKey = JSON.stringify({ query, params });
  if (queryCache.has(cacheKey)) {
    return queryCache.get(cacheKey);
  }
  const result = await sanityClient.fetch(query, params);
  queryCache.set(cacheKey, result);
  return result;
};

const builder = imageUrlBuilder(sanityClient);

export function urlFor(source: any) {
  return builder.image(source);
}
